import { actionDeclarer } from '../services/actionDeclarer';

export const {
	RESET_SUBMISSIONS_TABLE_STATE,
	SET_COORDINATION,
	SET_COORDINATION_OPTIONS,
	SET_TEMPLATE,
	SET_TEMPLATES,
	SET_TEMPLATE_MODULES,
	SET_TEMPLATE_MODULE_FILTERS,
	SET_TEMPLATE_MODULE_TAGS,
	SET_TEMPLATE_OCCURRENCES,
	SET_TEMPLATE_REQUIREMENTS,
	SET_TEMPLATE_STATUSES,
	SET_TEMPLATE_TYPES,
	SET_PARTICIPANTS,
	SET_PROGRAM,
	SET_PROGRAM_LIST,
	SET_PROGRAM_STATUSES,
	SET_PROGRAM_TYPES,
	SET_SUBMISSIONS,
	SET_SUBMISSIONS_TABLE_STATE,
	SET_TABLE_STATE
} = actionDeclarer;

const programsReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case RESET_SUBMISSIONS_TABLE_STATE:
			return {
				...state,
				submissionsTableState: {
					filters: [],
					pageIndex: 0,
					pageSize: 10,
					rows: [],
					selectedIds: [],
					sortBy: []
				}
			};
		case SET_COORDINATION:
			return {
				...state,
				program: {
					...state.program,
					coordinators: payload
				}
			};
		case SET_COORDINATION_OPTIONS:
			return {
				...state,
				coordinationOptions: payload
			};
		case SET_PARTICIPANTS:
			return {
				...state,
				program: {
					...state.program,
					participants: payload
				}
			};
		case SET_PROGRAM:
			return {
				...state,
				program: payload
			};
		case SET_PROGRAM_LIST:
			return {
				...state,
				programList: payload
			};
		case SET_PROGRAM_STATUSES:
			return {
				...state,
				programStatuses: payload
			};
		case SET_PROGRAM_TYPES:
			return {
				...state,
				programTypes: payload
			};
		case SET_SUBMISSIONS:
			return {
				...state,
				submissions: payload
			};
		case SET_SUBMISSIONS_TABLE_STATE:
			return {
				...state,
				submissionsTableState: payload( state.submissionsTableState )
			};
		case SET_TABLE_STATE:
			return {
				...state,
				tableState: payload( state.tableState )
			};
		case SET_TEMPLATE:
			return {
				...state,
				template: payload
			};
		case SET_TEMPLATES:
			return {
				...state,
				templates: payload
			};
		case SET_TEMPLATE_MODULES:
			return {
				...state,
				templateModules: payload
			};
		case SET_TEMPLATE_MODULE_FILTERS:
			return {
				...state,
				templateModuleFilters: payload
			};
		case SET_TEMPLATE_MODULE_TAGS:
			return {
				...state,
				templateModuleTags: payload
			};
		case SET_TEMPLATE_OCCURRENCES:
			return {
				...state,
				templateOccurrences: payload
			};
		case SET_TEMPLATE_STATUSES:
			return {
				...state,
				templateStatuses: payload
			};
		case SET_TEMPLATE_REQUIREMENTS:
			return {
				...state,
				templateRequirements: payload
			};
		case SET_TEMPLATE_TYPES:
			return {
				...state,
				templateTypes: payload
			};
		default:
			return state;
	}
};

export default programsReducer;
